import { useFormik } from "formik";
import Select from "../../../components/select";
import { usePortList, useSubnetList } from "../layout/resuableEffect";
import * as Yup from "yup";
import Input from "../../../components/input";
import arrow from "../../../assets/svg-icons/blueArrow.svg";
import { useDispatch, useSelector } from "react-redux";
import { createNetworkPorts, deleteSubnetPort, listNetwork, projectPortList, updateNetworkPort } from "../../../hooks/local/userReducer";
import { useNavigate } from "react-router-dom";
import TextArea from "../../../components/textArea";
import { useState } from "react";
import { extractLastNumbers, FormatDate } from "../../../hooks/constants";
import close from "../../../assets/svg-icons/closeBrand.svg";
import Button from "../../../components/button";
import Modal from "../../../components/modal";


const Ports = () => {

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const selectedProject = useSelector((state) => state.user.selectedProject);
  const selectedNetwork = JSON.parse(sessionStorage.getItem("selectedNetwork"));

  const [searchText, setSearchText] = useState("");
  const [portModal, setPortModal] = useState(false);
  const [managePortModal, setManagePortModal] = useState(false);
  const [editPortModal, setEditPortModal] = useState(false);
  const [deletePortModal, setDeletePortModal] = useState(false); 
  const [selectedPort, setSelectedPort] = useState(null);



    const createPort = useFormik({
      initialValues: {
        portName: "",
        description: "",
      },
      validationSchema: Yup.object({
        portName: Yup.string().required("Name is required"),
      }),
      onSubmit: async (values) => {
        const { portName, description } = values;
        const networkData = {
          name: portName,
          // description,
          network_id: selectedNetwork?.networkId,
          projectId: selectedProject?.id,
        };
  
        const { payload } = await dispatch(createNetworkPorts(networkData));
        if (payload.statuscode === "00") {
          window.location.reload();
        }
      },
    });
  
    const editPort = useFormik({
  
      initialValues: {
        portName: selectedPort?.name || "",
        description: selectedPort?.description || "",
      },
      
      enableReinitialize: true, 
      validationSchema: Yup.object({
        portName: Yup.string().required("Name is required"),
      }),
  
      onSubmit: async (values) => {
        const { portName, description } = values;
  
        const networkData = {
            name: portName,
            // description,
            network_id: selectedNetwork?.networkId,
            portId: selectedPort?.id,
            projectId: selectedProject?.id,
        };
  
        const { payload } = await dispatch(updateNetworkPort(networkData)); 
        if (payload.statuscode === "00") {
          setEditPortModal(false);
          window.location.reload();
        }
      },
    });



  const handleSearchChange = (event) => {
    setSearchText(event.target.value);
    setCurrentPage(1);
  };

  const options = [
    { value: "all-ports", label: "All ports" },
    { value: "name", label: "Port Name" },
  ];

  
  
    const showManagePortModal = (key, data) => {
      setManagePortModal(key);
      const portDetails = { portId: data.id, portName: data.name };
      sessionStorage.setItem("selectedPort", JSON.stringify(portDetails));
    };
    
   const closeManageNetworkModal = () => {
      setManagePortModal(false);
   };
  
  
    const togglePortModal = () => {
      setPortModal(!portModal);
    };
  
    const toggleEditPortModal = (port) => {
        console.log(port);

      setSelectedPort(port);
      setEditPortModal(!editPortModal);
    };

    const params = `?network_id=${selectedNetwork?.networkId}`
    const portList = usePortList(selectedProject?.id, params);


    const portListMap = Array.isArray(portList)
        ? portList.map((port) => ({
            id: port.id,
            name: `(${extractLastNumbers(port.id)})`,
            fixedIPs: port?.fixed_ips && port?.fixed_ips.length > 0
            ? (port?.fixed_ips[0].ip_address ?? "N/A")
            : "N/A",
            macAddress: port?.mac_address || "N/A",
            adminState: port?.admin_state_up ? "UP" : "DOWN",
            status: port?.status || "N/A",
            description: port?.description || "N/A",
            attachedDevice: port?.device_owner || "N/A",
            createdAt: FormatDate(port.created_at),
        }))
        : [];

      const [currentPage, setCurrentPage] = useState(1);
      const entriesPerPage = 5;
    
      const filteredData = portListMap?.filter((row) =>
        row?.status?.toLowerCase().includes(searchText.toLowerCase())
      );
    
      const indexOfLastEntry = currentPage * entriesPerPage;
      const indexOfFirstEntry = indexOfLastEntry - entriesPerPage;
      const currentEntries = filteredData.slice(
        indexOfFirstEntry,
        indexOfLastEntry,
      );
      const totalPages = Math.ceil(filteredData.length / entriesPerPage);
    
      const handlePreviousPage = () => {
        if (currentPage > 1) {
          setCurrentPage(currentPage - 1);
        }
      };
    
      const handleNextPage = () => {
        if (currentPage < totalPages) {
          setCurrentPage(currentPage + 1);
        }
      };
        
     const handleServerAction = async (action, portId) => {
       const projectId = selectedProject.id;
       const { payload } = await dispatch(action({ projectId, portId }));
   
       if (payload.statuscode === "00") {
         window.location.reload();
       }
     };
    

    const deletePort = (portId) =>
      handleServerAction(deleteSubnetPort, portId);


  return (
    <div className="min-h-screen px-4 md:px-10 pt-6 pb-10 dark:text-white">

        <div>
            {portListMap?.length > 0 ?
            <div>

                <div className="w-full flex justify-between items-center gap-4 lg:flex-row flex-col mb-10">

                    <div className="w-full md:w-[initial] grid grid-cols-1 md:grid-cols-12 gap-4 items-end my-10">
                        <div className="md:col-span-3">
                            <Select label="Filter ports" name="ports" options={options} />
                        </div>
                        <div className="md:col-span-4">
                            <input
                                type="search"
                                name=""
                                value={searchText}
                                onChange={handleSearchChange}
                                placeholder="Search for port..."
                                className="bg-white text-black w-full p-4 text-sm rounded-md border border-[#c4c4c460] active:outline-0 focus:outline-0 placeholder:opacity-70 placeholder:text-xs dark:bg-slate-800 dark:text-white"
                            />
                        </div>
                    </div>

                    <div
                        className="px-4 py-3 text-xs border-[1.5px] border-primaryBlue rounded-md text-primaryBlue cursor-pointer w-fit"
                        onClick={togglePortModal}
                    >
                        Create port
                    </div>

                </div>  

                <div className="overflow-x-auto rounded-md border dark:border-[#c4c4c432]">
                <table className="w-full text-sm text-left overflow-hidden">
                    <thead className="bg-white dark:bg-slate-800 px-3 md:px-4 border text-gray-400 dark:border-[#c4c4c432] border-b text-sm font-semibold">
                    <tr>
                        <th scope="col" className="px-6 py-4 whitespace-nowrap w-5">
                            #
                        </th>
                        <th scope="col" className="px-6 py-4 whitespace-nowrap max-w-52">
                            Port name
                        </th>
                        <th scope="col" className="px-6 py-4 whitespace-nowrap">
                            Fixed IPS
                        </th>
                        <th scope="col" className="px-6 py-4 whitespace-nowrap">
                            MAC Address
                        </th>
                        <th scope="col" className="px-6 py-4 whitespace-nowrap">
                            Attached Device
                        </th>
                        <th scope="col" className="px-6 py-4 whitespace-nowrap">
                            Admin State
                        </th>
                        <th scope="col" className="px-6 py-4 whitespace-nowrap">
                            Status
                        </th>
                        <th scope="col" className="px-6 py-4 whitespace-nowrap">
                            Actions
                        </th>
                    </tr>
                    </thead>
                    <tbody className="bg-white dark:bg-slate-800 px-3 md:px-4 border rounded-b-md dark:border-[#c4c4c432] border-t-2 text-sm">
                    {currentEntries.map((row, index) => (
                        <tr
                        key={index}
                        className="dark:hover:bg-[#ffffff05] hover:bg-brandBlue/25 whitespace-nowrap"
                        >
                        <td className="text-start py-4 px-6">{index + 1}.</td>
                        <td className="text-start py-4 px-6">{row.name}</td>
                        <td className="text-start py-4 px-6">{row.fixedIPs}</td>
                        <td className="text-start py-4 px-6">{row.macAddress}</td>
                        <td className="text-start py-4 px-6">{row.attachedDevice}</td>
                        <td className="text-start py-4 px-6">{row.adminState}</td>
                        <td className="text-start py-4 px-6">{row.status}</td>
                        <td className="text-start py-4 px-6">
                            <button
                                className="text-white p-3 text-xs rounded bg-primaryBlue w-full md:w-fit"
                                onClick={() => showManagePortModal(index, row)}
                            >
                                Manage Port
                            </button>

                            {managePortModal === index && (
                                <div className="w-full fixed h-screen bg-black/70 top-0 left-0 px-4 flex items-end md:items-center justify-center z-50">
                                    <div className="bg-white dark:bg-[#141D26] rounded w-full md:w-[30%] dark:text-white max-h-[80%] mb-4 md:mb-0 overflow-auto">
                                    <div className="flex justify-between items-center text-sm p-6 border-b dark:border-b-[#c4c4c432]">
                                        <div className="flex gap-2 items-center">
                                            <span className="dark:text-white">
                                                Manage "{row.name}"
                                            </span>
                                            </div>
                                            <img
                                                src={close}
                                                onClick={closeManageNetworkModal}
                                                className="h-5 cursor-pointer"
                                                alt=""
                                            />
                                        </div>
                                        <div className="p-4 grid gap-1">
    
                                            <div className="flex items-center justify-between hover:rounded border-b dark:border-[#c4c4c424] last:border-none py-4 px-3 hover:bg-primaryBlue/5 transition-all cursor-pointer" onClick={() => toggleEditPortModal(row)}>
                                                <span>Edit port</span>
                                                <span>
                                                    <img src={arrow} alt="" className="" />
                                                </span>
                                            </div>

                                            <div
                                              className="flex justify-self-center text-red-500 rounded-md py-5 px-3 text-center cursor-pointer"
                                              onClick={() => {
                                                setDeletePortModal(true);
                                              }}
                                            >
                                              <span className="hover:underline">
                                                Delete port
                                              </span>
                                            </div>
                                        </div>
                                        <Modal
                                          title={"Delete Port"}
                                          isVisible={deletePortModal}
                                          onClose={() => setDeletePortModal(false)}
                                        >
                                          <div className="text-sm text-center pt-6 text-wrap">
                                            Are you sure you want to delete{" "}
                                            <span className="underline">{row.name}</span> .
                                            This action cannot be undone.
                                          </div>
                                          <div className="grid gap-4 justify-center py-6">
                                            <button
                                              className="bg-red-500 text-white text-xs px-6 py-4 rounded-sm w-fit"
                                              onClick={() => deletePort(row.id)}
                                            >
                                              Yes, delete {row.name}
                                            </button>
                                            <button
                                              className="text-[#1DA1F2] text-sm px-6 py-2 hover:underline"
                                              onClick={() => setDeletePortModal(false)}
                                            >
                                              Cancel
                                            </button>
                                          </div>
                                        </Modal>
                                    </div>
                                </div>
                            )}
    
                        </td>
    
                        </tr>
                    ))}
                    </tbody>
                </table>
                </div>
                <div className="grid justify-center gap-4 md:flex md:justify-between items-center mt-4">
                <p className="text-gray-400 text-sm">
                    Showing{" "}
                    <span className="font-medium text-black dark:text-white">
                        {indexOfFirstEntry + 1}
                    </span>{" "}
                        to{" "}
                    <span className="font-medium text-black dark:text-white">
                        {Math.min(indexOfLastEntry, portListMap?.length)}
                    </span>{" "}
                        of{" "}
                    <span className="font-medium text-black dark:text-white">
                        {portListMap?.length}
                    </span>{" "}
                    results
                </p>
                <div className=" flex gap-3">
                    <button
                        className={`bg-white dark:bg-primaryBlue border dark:border-none rounded-md py-3 px-5 text-sm ${currentPage === 1 ? "opacity-50" : "opacity-100"}`}
                        onClick={handlePreviousPage}
                        disabled={currentPage === 1}
                    >
                        Previous
                    </button>
                    <button
                        className={`bg-white dark:bg-primaryBlue border dark:border-none rounded-md py-3 px-5 text-sm ${currentPage === totalPages ? "opacity-50" : "opacity-100"}`}
                        onClick={handleNextPage}
                        disabled={currentPage === totalPages}
                    >
                        Next
                    </button>
                </div>
                </div>
            </div>
    
            :
    
            <>
                <div className="md:px-52 text-center grid text-gray-500 mt-32">
                    <div>It looks like you don't have ports attached to this network yet. Once you create a port, your ports will appear here.</div>
                </div>
            
            </> 
            
            }
            
        </div>

                {/* network modal */}
                {portModal && (
                    <div className="fixed top-0 h-screen w-full left-0 z-50 bg-black/60 flex items-center justify-center p-4">
                        <div className="bg-white dark:bg-[#141D26] rounded-md p-4 md:p-10 w-full md:w-1/3 max-h-[80%] overflow-y-scroll">
                            <div className="flex items-center justify-between mb-4">
                                <p className="text-primaryBlue">Create a port</p>
                                <span onClick={togglePortModal} className="cursor-pointer">
                                    <img alt="" src={close} className="h-5" />
                                </span>
                            </div>
                
                            <form className="gap-y-6 grid" onSubmit={createPort.handleSubmit}>
                                <Input
                                    label={"Port name"}
                                    type={"text"}
                                    name={"portName"}
                                    value={createPort.values.portName}
                                    onBlur={createPort.handleBlur}
                                    onChange={createPort.handleChange}
                                    onError={
                                    createPort.errors.portName &&
                                    createPort.touched.portName
                                        ? createPort.errors.portName
                                        : null
                                    }
                                />
        
                                <TextArea
                                    label={"Description"}
                                    type={"text"}
                                    name={"description"}
                                    value={createPort.values.description}
                                    onBlur={createPort.handleBlur}
                                    onChange={createPort.handleChange}
                                    onError={
                                        createPort.errors.description &&
                                        createPort.touched.description
                                            ? createPort.errors.description
                                            : null
                                        }
                                />
        
        
                                <div className="flex justify-between items-center gap-2">
                                    <Button 
                                        buttonText={"Create Port"} 
                                        buttonRole={"submit"} 
                                    />
                                </div>
                
                            </form>
                        </div>
                    </div>
                )}
        
        
            {/* Edit Port Modal */}
              {editPortModal && selectedNetwork && (
                <div className="fixed top-0 h-screen w-full left-0 z-50 bg-black/60 flex items-center justify-center p-4">
                  <div className="bg-white dark:bg-[#141D26] rounded-md p-4 md:p-10 w-full md:w-1/3 max-h-[80%] overflow-y-scroll">
                    <div className="flex items-center justify-between mb-4">
                      <p className="text-primaryBlue">Edit Port "{selectedPort?.name}"</p>
                      <span onClick={() => toggleEditPortModal(null)} className="cursor-pointer">
                        <img alt="" src={close} className="h-5" />
                      </span>
                    </div>
        
                    <form className="gap-y-6 grid" onSubmit={editPort.handleSubmit}>
                      <Input
                        label={"Port name"}
                        type={"text"}
                        name={"portName"}
                        value={editPort.values.portName}
                        onBlur={editPort.handleBlur}
                        onChange={editPort.handleChange}
                        onError={
                          editPort.errors.portName && editPort.touched.portName
                            ? editPort.errors.portName
                            : null
                        }
                      />
        
                      <TextArea
                        label={"Description"}
                        type={"text"}
                        name={"description"}
                        value={editPort.values.description}
                        onBlur={editPort.handleBlur}
                        onChange={editPort.handleChange}
                        onError={
                          editPort.errors.description && editPort.touched.description
                            ? editPort.errors.description
                            : null
                        }
                      />
        
                      <div className="flex justify-between items-center gap-2">
                        <Button 
                            buttonText={"Update Port"} 
                            buttonRole={"submit"} 
                        />
                      </div>
                    </form>
                  </div>
                </div>
              )}
              
        



    </div>
  );
};

export default Ports;
